import GSAP from "gsap";

// Global config - tweak these values as needed
const CONFIG = {
  ROTATION_INTERVAL: 2000, // Time between each image change (ms)
  HOVER_DELAY: 2000, // Delay before rotation starts on hover (ms)
  TRANSITION_DURATION: 0.6, // GSAP fade transition duration (seconds)
};

export default function projectCardHover() {
  const cardWrappers = document.querySelectorAll(".image_changer_wrapper");
  if (cardWrappers.length === 0) return;

  const intervals = [];
  const timeouts = [];

  cardWrappers.forEach((cardWrapper) => {
    const images = cardWrapper.querySelectorAll(".image_rollover");
    const number = cardWrapper.querySelector(".slider_number");
    if (images.length <= 1) return;
    let currentIndex = 0;
    let intervalId = null;
    let hoverTimeoutId = null;

    images.forEach((img) => {
      img.style.position = "absolute";
      img.style.top = "0";
      img.style.left = "0";
      img.style.width = "100%";
      img.style.height = "100%";
      img.style.objectFit = "cover";
    });

    GSAP.set(images, { opacity: 0 });
    GSAP.set(images[0], { opacity: 1 });

    const updateNumber = (index) => {
      if (number) {
        number.textContent = String(index + 1).padStart(2, "0");
      }
    };

    updateNumber(0);

    const resetToFirst = () => {
      GSAP.killTweensOf(images);

      // If already on first image, do nothing (prevents flash)
      if (currentIndex === 0) return;

      // Smoothly fade out current image and fade in first image
      const tl = GSAP.timeline();
      tl.set(images[0], { opacity: 0, zIndex: 2 })
        .to(images[currentIndex], {
          opacity: 0,
          duration: CONFIG.TRANSITION_DURATION,
          ease: "power2.out",
        })
        .to(
          images[0],
          {
            opacity: 1,
            duration: CONFIG.TRANSITION_DURATION,
            ease: "power2.out",
          },
          "<",
        )
        .set(images[0], { zIndex: 1 })
        .set(images[currentIndex], { zIndex: 0 });

      currentIndex = 0;
      updateNumber(0);
    };

    const rotateImages = () => {
      const prevIndex = currentIndex;
      currentIndex = (currentIndex + 1) % images.length;

      const tl = GSAP.timeline();

      tl.set(images[currentIndex], { opacity: 0, zIndex: 2 })
        .set(images[prevIndex], { zIndex: 1 })
        .to(images[currentIndex], {
          opacity: 1,
          duration: CONFIG.TRANSITION_DURATION,
          ease: "power2.out",
        })
        .to(
          images[prevIndex],
          {
            opacity: 0,
            duration: CONFIG.TRANSITION_DURATION,
            ease: "power2.out",
          },
          "<",
        )
        .set(images[currentIndex], { zIndex: 1 })
        .set(images[prevIndex], { zIndex: 0 });

      updateNumber(currentIndex);
    };

    const startRotation = () => {
      if (intervalId) return;
      intervalId = setInterval(rotateImages, CONFIG.ROTATION_INTERVAL);
      intervals.push(intervalId);
      rotateImages();
    };

    const stopRotation = () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      resetToFirst();
    };

    const handleMouseEnter = () => {
      hoverTimeoutId = setTimeout(() => {
        startRotation();
      }, CONFIG.HOVER_DELAY);
      timeouts.push(hoverTimeoutId);
    };

    const handleMouseLeave = () => {
      if (hoverTimeoutId) {
        clearTimeout(hoverTimeoutId);
        hoverTimeoutId = null;
      }
      stopRotation();
    };

    cardWrapper.addEventListener("mouseenter", handleMouseEnter);
    cardWrapper.addEventListener("mouseleave", handleMouseLeave);
  });

  return () => {
    intervals.forEach(clearInterval);
    timeouts.forEach(clearTimeout);
  };
}
